import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=2f1f30ce"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=2f1f30ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports